// eslint-disable-next-line import/prefer-default-export
export function getUnreadCount (state) {
    return state.unreadCount;
}

export function getUnreadTotal (state) {
    return state.unreadTotal;
}
